import graphApi from '@/api';
import { ConnectionOptions, GraphApiMethod } from '@/api/core';
import SendInvoiceEmail from '@/api/queries/invoices/SendInvoiceEmail';
import { SendInvoiceEmailInput, SendInvoiceEmailResponse, MutationSendInvoiceEmailArgs } from '@/models/gen/graphql';
import { getProperty } from '@/utils';
import { TypedDocumentNode } from '@apollo/client';

type ServiceMethodPayload = {
  [key in keyof SendInvoiceEmailInput]?: SendInvoiceEmailInput[key];
};

interface ServiceMethod {
  (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<SendInvoiceEmailResponse>;
}

export const { sendInvoiceEmail } = ((): {
  sendInvoiceEmail: ServiceMethod;
} => {
  const [fetch] = graphApi(SendInvoiceEmail).map(
    (fn: GraphApiMethod<TypedDocumentNode>): ServiceMethod =>
      async (payload?: SendInvoiceEmailInput, options?: ConnectionOptions): Promise<SendInvoiceEmailResponse> => {
        const args: MutationSendInvoiceEmailArgs = {
          input: payload,
        };
        const opts = { merge: options?.merge ? 'sendInvoiceEmail' : undefined };
        const res = await fn(args, opts);
        return getProperty('sendInvoiceEmail', res);
      }
  );
  return {
    sendInvoiceEmail: fetch,
  };
})();
